export { PlatformPay } from '@stripe/stripe-react-native/src/types'

export const isPlatformPaySupported = () => new Promise((resolve) => resolve(false))

export const PlatformPayButton = () => null
